<template>
    <div
        :class="{'is-disabled': disabled}"
        class="checkbox"
    >
        <input
            v-model="isChecked"
            :id="checkboxId"
            :disabled="disabled"
            :name="name"
            type="checkbox"
        >
        <label
            v-bastards
            :for="checkboxId"
            :class="checkboxClasses"
        >
            {{ isRequired ? label + '&nbsp;*' : label }}
            <slot />
        </label>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            required: true
        },
        checkboxClasses: {
            type: String,
            default: ''
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        initialValue: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            isChecked: false,
            checkboxId: null,
        }
    },

    watch: {
        isChecked() {
            this.$emit('checkboxToggle', this.isChecked)
        }
    },

    mounted() {
        this.isChecked = this.initialValue
        this.checkboxId = `checkbox-${this._uid}`
    },

    methods: {
        forceChecked(isChecked) {
            this.isChecked = isChecked
        }
    }
}
</script>

<style lang="scss">
@import 'src/assets/scss/_variables/color';
@import 'src/assets/scss/_variables/mixin';

.checkbox {
    label {
        cursor: pointer;
        position: relative;
        padding-left: 27px;
        font-size: 17px;
        font-weight: 600;

        &:before {
            content: '';
            @include size(22px);
            border-radius: 3px;
            border: 1px solid #cdcdcd;
            position: absolute;
            top: 0;
            left: 0;
            transition: 0.1s;
        }

        &:after {
            content: '✔';
            visibility: hidden;
            pointer-events: none;
            opacity: 0;
            transform: scale(1.382);
            @include size(22px);
            border-radius: 3px;
            color: $color-primary;
            position: absolute;
            text-align: center;
            top: 5px;
            left: 0;
            font-size: 20px;
            line-height: 15px;
            transition: 0.1s;
        }

        &.selected-checkmark {
            &:after {
                content: '✔';
                font-size: 14px;
                padding-top: 2px;
            }
        }

        &.border-primary {
            &:before {
                border: 2px solid $color-primary;
            }
        }

        &:hover {
            &:before {
                border-color: $color-primary;
            }
        }
    }

    &--error {
        label::before {
            border: 1px solid red;
        }
    }

    input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        opacity: 0;

        &:checked {
            & + label {
                &:after {
                    visibility: visible;
                    pointer-events: all;
                    opacity: 1;
                    transform: none;
                }
            }
        }
    }

    &--block {
        label {
            display: block;
        }
    }

    &.is-disabled {
        opacity: 0.4;
        pointer-events: none;
    }
}
</style>
